import React, { useEffect, useState } from "react";
import PT from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import { IS_OPEN_LOGIN_FORM } from "../../helper/actions";
import { ACCOUNT_DETAILS_URL } from "../../../constants";
import { getFirebaseUser } from "../../helper/api";
import "./user-data.m.css";

class UserDataBaseHandler extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showUserData: false
    };
  }

  // componentDidMount() {
  //   this.props.initAccessType(userSubscription);
  // }

  logoutHandler = event => {
    event.persist();
    event.preventDefault();
    event.stopPropagation();
    this.props
      .logout()
      .then(() => {
        this.props.onBackdropClick(false);
        this.props.manageLoginForm(false);
        this.setState({ showUserData: !this.state.showUserData });
        // eslint-disable-next-line no-undef
        localStorage.setItem("one-tap-display", true);
      })
      .catch(error => {
        console.warn("Logout failed", error);
        return null;
      });
  };

  profileHandler = () => {
    this.setState({ showUserData: !this.state.showUserData });
    // eslint-disable-next-line no-undef
    // localStorage.setItem("one-tap-display", !this.state.showUserData);
    this.props.navigateTo(ACCOUNT_DETAILS_URL);
  };

  savedHandler = () => {
    this.props.navigateTo("/saved-stories");
  };

  render() {
    const { avatarName } = this.props;
    // const { member = {}, publisherConfig, avatarName } = this.props;
    // const imageUrl = member["avatar-s3-key"] ? publisherConfig["cdn-image"] + member["avatar-s3-key"] : userIcon;
    const imageUrl = `https://ui-avatars.com/api/?name=${avatarName}&background=ec2227&color=fff&size=128&length=1`;

    return (
      <div styleName="wrapper">
        <div
          styleName="user-details"
          onClick={() =>
            this.setState({ showUserData: !this.state.showUserData })
          }
        >
          <img src={imageUrl} styleName="memberIcon" />
        </div>
        {this.state.showUserData && (
          <div styleName="overlay">
            <ul styleName="lists">
              <li onClick={this.profileHandler}>My Profile</li>
              <li onClick={this.savedHandler}>Saved Stories</li>
              <li onClick={this.logoutHandler}>Logout</li>
            </ul>
          </div>
        )}
      </div>
    );
  }
}

UserDataBaseHandler.propTypes = {
  logout: PT.func,
  onBackdropClick: PT.func,
  member: PT.object,
  publisherConfig: PT.object,
  avatarName: PT.string,
  manageLoginForm: PT.func,
  navigateTo: PT.func,
  initAccessType: PT.func,
  getSubscriptionForUser: PT.func,
  userSubscriptionDetails: PT.func,
  userSubscriptionDetailsLoading: PT.func
};

const userDataBase = props => {
  const [name, setName] = useState("+");
  useEffect(() => {
    (async () => {
      try {
        const fireUser = await getFirebaseUser();
        setName(
          `${get(fireUser, ["data", "first_name"], "N") || "N"}+${get(
            fireUser,
            ["data", "last_name"],
            "L"
          ) || "L"}`
        );
      } catch (e) {
        console.log(e);
      }
    })();
  }, []);
  return <UserDataBaseHandler avatarName={name} {...props} />;
};

userDataBase.propTypes = {
  publisherConfig: PT.object
};

const mapDispatchToProps = dispatch => ({
  manageLoginForm: function(payload) {
    dispatch({
      type: IS_OPEN_LOGIN_FORM,
      payload: payload
    });
  },
  navigateTo: url => global.app.navigateToPage(dispatch, url)
});

const mapStateToProps = state => ({
  publisherConfig: get(state, ["qt", "config", "publisher"], {})
});

export const UserData = connect(
  mapStateToProps,
  mapDispatchToProps
)(userDataBase);
